import React from 'react';
import styled from 'styled-components';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLFieldSetElement>,
    HTMLFieldSetElement
  > {
  label?: string;
}

export const FieldSet = ({
  label,
  children,
  ref,
  ...props
}: Props & {ref?: React.Ref<HTMLFieldSetElement>}) => {
  return (
    <StyledFieldSet {...props} ref={ref}>
      {label && <GroupLabel>{label}</GroupLabel>}
      {children}
    </StyledFieldSet>
  );
};

const GroupLabel = styled.legend`
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.bold};
  line-height: 1.33;
  margin-bottom: 20px;
  position: relative;
  margin-left: -2px;
`;

const StyledFieldSet = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
`;
